import React from 'react'

import ChangeLog from '../components/changelog/ChangeLog'
const ChangeLogScreen = props => <ChangeLog {...props} />

export default ChangeLogScreen
